/**
 * Download Service
 * Manifest-based bulk download via Cloudflare Worker
 */

import type { DownloadFormatType } from "@/types";

const THUMBNAIL_WORKER_URL = "https://thumbnail-worker.luca-giorcelli.workers.dev";

export interface ManifestResult {
  manifestId: string;
  manifestUrl: string;
  macScriptUrl: string;
  winScriptUrl: string;
  estimatedSizeGB: number;
  fileCount: number;
}

/**
 * Request manifest generation for large downloads (>1GB)
 * Calls the thumbnail-worker to generate manifest + download scripts on R2
 */
export async function createManifestJob(
  userId: string,
  viewId: string,
  viewName: string,
  photoIds: string[],
  format: DownloadFormatType,
  idToken: string
): Promise<ManifestResult> {
  const response = await fetch(`${THUMBNAIL_WORKER_URL}/generate-manifest`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${idToken}`,
    },
    body: JSON.stringify({ userId, viewId, viewName, photoIds, format }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: "Unknown error" }));
    throw new Error((errorData as { error: string }).error || `Manifest generation failed: ${response.status}`);
  }

  return response.json() as Promise<ManifestResult>;
}
